// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3kPdA","file":"styles_file__1xD3G"};